import "./index.scss";
import React, { FC } from "react";
import { MoreOutlined } from "@ant-design/icons";
import { SurveyType } from "../../types/surveyType";
import { Popover } from "antd";
import { useNavigate } from "react-router-dom";
import { content } from "./content";
import { useActions } from "../../hooks/useActions";
import { SURVEYS_PAGE } from "../../utils/paths";
import { useRequests } from "../../hooks/useRequests";
import { duplicateSurvey } from "../../store/slices/surveys/surveysService";
import { useAppDispatch } from "../../store";
import { ChannelEnum } from "../../types/channelEnum";
import { DistributionChannelTypeEnum } from "../../types/DistributionChannel";
import { I18n } from "react-redux-i18n";
import { useDistributionChannelsApi } from "../../hooks/useDistributionChannelsApi";

const SurveyTableActionsComponent: FC<{
  readonly survey: SurveyType;
}> = ({ survey }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { activateSurvey, deactivateSurvey } = useActions();
  const { createDistributionChannel } = useDistributionChannelsApi();
  const { deleteSurvey } = useRequests();

  const _content = content({
    survey,
    onActivate: () => activateSurvey(survey?.surveyId),
    onDeactivate: () => deactivateSurvey(survey?.surveyId),
    onDelete: () => deleteSurvey(survey?.surveyId),
    onDuplicate: async () => {
      duplicateSurvey(survey?.surveyId, dispatch).then(async (survey) => {
        if (survey.communicationChannel === ChannelEnum.WEB) {
          await createDistributionChannel({
            surveyId: survey?.surveyId ?? "",
            channelType: DistributionChannelTypeEnum.URL,
            description: I18n.t("linkToSurvey"),
          });
        }
      });
    },
    onEdit: () => navigate(`${SURVEYS_PAGE}/${survey?.surveyId}/edit`),
  });

  return (
    <div>
      <Popover trigger="click" placement="left" content={_content} overlayInnerStyle={{ padding: 0 }}>
        <MoreOutlined className={"surveys-table-actions-button"} />
      </Popover>
    </div>
  );
};

export default SurveyTableActionsComponent;
